export default "__VITE_ASSET__3656b608__"